import AccountSetup from "./account-setup";
import AddPayment from "./add-payment";
import SignInPage from "./sign-in";
import Signup from "./sign-up";
import VerifyEmail from "./VerifyEmail";

const routes = [
  {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    route: "/sign-in",
    component: <SignInPage />,
  },
  {
    type: "collapse",
    name: "Sign Up",
    key: "sign-up",
    route: "/sign-up",
    component: <Signup />,
  },
  {
    type: "collapse",
    name: "Verify Email",
    key: "verify-email",
    route: "/verify-email",
    component: <VerifyEmail />,
  },
  {
    type: "collapse",
    name: "Account Setup",
    key: "account-setup",
    route: "/account-setup",
    component: <AccountSetup />,
  },
  {
    type: "collapse",
    name: "Payment Setup",
    key: "add-payment",
    route: "/add-payment",
    component: <AddPayment />,
  },
];

export default routes;
